module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About The Author")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.39567in",
      "height": "1.98852in"
    },
    attrs: {
      "alt": "",
      "src": "Images/file0.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("C:\\Users\\Marketing 4\\AppData\\Local\\Microsoft\\Windows\\INetCache\\Content.Word\\7.jpg")])]), _vm._v(" "), _c('p', [_vm._v("The author is a singer-songwriter, poet, radio-TV presenter, actor and voice-over artist who descended into the abyss of crime, violence and drug addiction, but found the strength, courage and support to ascend in life. Enriched by these experiences, the author now seeks to empower those grappling with such challenges and to steer others clear from the mental and physical prison of torture, pain, anger, regret, remorse, resistance, guilt and shame.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0